<template>
    <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11119_215814)">
            <path
                d="M71.5 93.6H32.5C28.9467 93.6 26 90.6533 26 87.1V16.9C26 13.3466 28.9467 10.4 32.5 10.4H71.5C75.0533 10.4 78 13.3466 78 16.9V87.0133C78 90.5666 75.0533 93.5133 71.5 93.5133V93.6ZM32.5 13C30.3333 13 28.6 14.7333 28.6 16.9V87.0133C28.6 89.18 30.3333 90.9133 32.5 90.9133H71.5C73.6667 90.9133 75.4 89.18 75.4 87.0133V16.9C75.4 14.7333 73.6667 13 71.5 13H32.5Z"
                fill="#230078" />
            <path
                d="M58.5866 83.2H45.5C44.8066 83.2 44.2 82.5933 44.2 81.9C44.2 81.2066 44.8066 80.6 45.5 80.6H58.5866C59.28 80.6 59.8866 81.2066 59.8866 81.9C59.8866 82.5933 59.28 83.2 58.5866 83.2Z"
                fill="#230078" />
            <path
                d="M39 52H57.2C60.06 52 62.4 54.34 62.4 57.2V59.8C62.4 62.66 60.06 65 57.2 65H33.8V57.2C33.8 54.34 36.14 52 39 52Z"
                fill="#84BD00" />
            <path
                d="M62.4 28.6C63.8733 28.6 65 29.7267 65 31.2V41.6H44.2C42.7267 41.6 41.6 40.4733 41.6 39V31.2C41.6 29.7267 42.7267 28.6 44.2 28.6H62.4ZM62.4 26H44.2C41.34 26 39 28.34 39 31.2V39C39 41.86 41.34 44.2 44.2 44.2H67.6V31.2C67.6 28.34 65.26 26 62.4 26Z"
                fill="#230078" />
        </g>
        <defs>
            <clipPath id="clip0_11119_215814">
                <rect width="104" height="104" fill="white" />
            </clipPath>
        </defs>
    </svg>

</template>